import {
    GREEN_600, RED_500, GREY_600, AMERICAN_YELLOW, YELLOW_500,
} from '../../../../constants';
import { HealthScoreOverallStatus } from '../types';

const getColorForStatus = (status?: HealthScoreOverallStatus): string => {
    const statusBgColors: Record<string, string> = {
        healthy: GREEN_600,
        stable: YELLOW_500,
        at_risk: AMERICAN_YELLOW,
        critical: RED_500,
    };
    return statusBgColors[status || ''] || GREY_600;
};

export default getColorForStatus;
